import { ref } from 'vue';

export default () => {
    const show = ref(false);
    const row = ref({});

    function open(r) {
        show.value = true;
        row.value = r || {};
    }

    function close() {
        show.value = false;
        row.value = {};
    }

    return { show, open, close, row }
}